<template>
    <button class="btn btn-danger btn-sm" @click="deleteUser" :disabled="disabled">
        <i class="fa-trash"></i> Permanently Delete
    </button>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            user: {required: true},
            disabled: {required: true}
        },

        methods: {
            async deleteUser() {
                if(this.disabled) return;
                const result = await this.$confirmDialog();
                if (!result) return;
                await this.$http.delete('/user/' + this.user.id + '/destroy')
                    .then(({data}) => {
                        this.$emit('user-deleted');
                        swal.fire({
                            title: 'User Successfully Deleted!',
                            type: 'success',
                        })
                    }).catch(error => {
                        console.error(error);
                        swal.fire({
                            title: 'Error!',
                            text: error.response?.data?.message || 'An error occurred while deleting the user.',
                            type: 'error',
                        });
                    });
            }
        }
    }
</script>
